import DtoPiezoSituationDayMeasure from './DtoPiezoSituationDayMeasure'

export default class DtoPiezoSituationDays {
    constructor(obj) {
        this.piezoId = obj.piezoId
        this.days = obj.days.map(d => new DtoPiezoSituationDayMeasure(d))
    }
}